import urls from "../utils/urls"
import { get,post} from '../utils/http'
const state= {
    
    result:{},
    address_id:0,
    code:0
    
}
const mutations={
   
    addAddress(state,value){

        post(urls.address.add,value).then((result)=>{
          
        
            state.result=result
          
         
          
         
             
          });
    },
    getAddressData(state,value){
        
        state.id=value.id
       
        get(urls.address.getData,{id:value.id}).then((result)=>{
          
          
          
          state.result=result.data
          state.address_id=result.address_id
       
        
       
           
        });
        
    },
    editAddress(state,value){
        
        state.id=value.id

       
       if(value.type=="get"){

       
        get(urls.address.edit,{id:value.id}).then((result)=>{
          
           
           
          
            state.result=result.data
         
         
          
         
             
          });


       }else{
       
        post(urls.address.edit,value).then((result)=>{
          
          
            if(result.code==404){
               
                return
             
              
               
            }

            state.result=result
          
         
         
          
         
             
          });
       }
       
        
    },
    deleteAddress(state,value){

        
        post(urls.address.delete,value).then((result)=>{
          
            
            state.result=result.data
            state.address_id=result.address_id
          
         
          
         
             
          });
    },
    setAddresss(state,value){
      
        post(urls.address.setAddress,value).then((result)=>{
          
            
           
            state.result=result.data
            state.address_id=result.address_id
          
         
          
         
             
          });

    }

}
const  actions={
    getAddressDataAction(context,value){
       
        context.commit("getAddressData",value)
       
    },
    addAddressAction(context,value){
       
        
        context.commit("addAddress",value)
       
    },
    deleteAddressAction(context,value){
       
        
        context.commit("deleteAddress",value)
       
    },
    editAddressAction(context,value){
       
        
        context.commit("editAddress",value)
       
    },
    setAddresssAction(context,value){
        context.commit("setAddresss",value)
    }
    
  
    
   

}

export default {state,mutations,actions}